import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { Row, Col, Label, Alert, Button, FormGroup, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import './CreateGroupModal.css'
import Select from 'react-select'
import { RepsTypeAhead } from '../../TaskManagement/TaskComponents/TypeAheadComponents'

import withApolloClient from '../../withApolloClient'

const CreateGroupMutation = gql`mutation CreateGroupMutation($input: CreateGroupMutationInput!){
    createGroup(input:$input){
        ok
        errors{
            messages
        }
    }
} `

const AllPermissions = gql`query AllPermissions{
    allPermissions{
        edges{
            node{
                id
                name
            }
        }
    } 
}`
class CreateGroupModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            name: "",
            selectedPermissions: [],
            selectedOwners: [],
            errorMessage: "",
            successMessage: "",
            loading: false
        }
    }
    createNewGroup = (e) => {
        try {
            if (this.state.name) {
                this.setState({ loading: true })
                let input = {
                    name: this.state.name,
                }
                if (this.state.selectedPermissions && this.state.selectedPermissions.length > 0) {
                    input["permissions"] = this.state.selectedPermissions
                }
                const ownerIds = (this.state.selectedOwners || []).filter(Boolean)
                if (ownerIds.length > 0) {
                    input["ownerIds"] = ownerIds
                }
                this.props.apolloClient.mutate({
                    mutation: CreateGroupMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.createGroup && result.data.createGroup.ok) {
                        this.setState({ errorMessage: "", successMessage: "Succesfully Created New Group" })
                    } else {
                        let errorMessage = "An error occurred, could not complete request."
                        if (result.data && result.data.createGroup && result.data.createGroup.errors && result.data.createGroup.errors[0] && result.data.createGroup.errors[0].messages) {
                            errorMessage = result.data.createGroup.errors[0].messages.toString()
                        }
                        this.setState({ errorMessage: errorMessage })
                    }
                    this.setState({ loading: false })
                }).catch((err) => {
                    let errorMessage = "An error has occured"
                    this.setState({ errorMessage: errorMessage, loading: false })
                })
            }
            else this.setState({ errorMessage: "Missing Required Field" })
        }
        catch (err) {
            let errorMessage = "An error has occured"
            this.setState({ errorMessage: errorMessage, loading: false })
        }
    }
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };
    componentDidMount() {
        const { apolloClient } = this.props
    }

    render() {
        return (
            <div>
                <Modal className="create-group-modal" isOpen={this.props.open}>
                    <ModalHeader>Create Group</ModalHeader>
                    <ModalBody>
                        {this.state.errorMessage &&
                            <Col xs={12}>
                                <Alert color="danger">
                                    {this.state.errorMessage}
                                </Alert>
                            </Col>
                        }
                        {this.state.successMessage &&
                            <Col xs={12}>
                                <Alert color="success">
                                    {this.state.successMessage}
                                </Alert>
                            </Col>
                        }
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="name">Group Name*</Label>
                                    <Input name="name" id="name" onChange={this.updateInput} placeholder="Group Name" invalid={!this.state.name} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="selectedPermissions">Select Permissions</Label>
                                    <Select
                                        className="bos-custom-select" classNamePrefix="bos-select"
                                        isLoading={!(this.props.allPermissions && this.props.allPermissions.edges && this.props.allPermissions.edges.length > 0)}
                                        options={this.props.allPermissions && this.props.allPermissions.edges && this.props.allPermissions.edges.length > 0 && this.props.allPermissions.edges.map(permission => ({ value: permission.node.id, label: permission.node.name }))}
                                        placeholder="Select Permissions"
                                        isMulti
                                        onChange={(permission) => this.setState({ selectedPermissions: permission.map(item => item.value) })}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label for="selectedOwners">Select Owners</Label>
                                    <RepsTypeAhead
                                        onChange={(owners) => this.setState({ selectedOwners: (owners || []).filter(Boolean) })}
                                        defaultValue={this.state.selectedOwners}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button outline className="create-group-modal-secondary-btn" onClick={this.props.handleClose}>Close</Button>
                        <Button className="create-group-modal-primary-btn" onClick={this.createNewGroup} disabled={!this.state.name}>{this.state.loading ? "Loading..." : "Add New Group"}</Button>{' '}
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}


//-----------------------------------
export default graphql(AllPermissions, {
    options: { fetchPolicy: 'cache-and-network' },
    props: ({ data: { loading, allPermissions } }) => ({ loading, allPermissions })
})(withApolloClient(CreateGroupModal))
